import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { t } from 'i18next'
import { useLazyQuery } from '@apollo/client';
import { GET_BOAT_AMENITIES } from 'graphql/boat/queries';



export function BoatAmenitiesCheckBox({ value, onChange, error, helperText }) {

  const [boatAmenitiesList, setBoatAmenitiesList] = useState(null)

  const [getBoatAmenitiesList, { loading: amenitiesListLoading, error: amenitiesListError }] = useLazyQuery(GET_BOAT_AMENITIES, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.boatFeaturesAmenities.length > 0) {
        setBoatAmenitiesList(data.boatFeaturesAmenities)
      }
    },
  })

  // get Amenities List
  const getBoatAmenities = () => {
    getBoatAmenitiesList({
      variables: {
        "code": null
      },
    })
  }
  useEffect(() => {
    getBoatAmenities();
  }, [boatAmenitiesList]);

  const [selectedAmenities, setSelectedAmenities] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value: checkboxValue, checked } = event.target;
    let updatedSkills;
    if (checked) {
      updatedSkills = [...value, checkboxValue]; // Add skill if checked
    } else {
      updatedSkills = value.filter((skill) => skill !== checkboxValue); // Remove skill if unchecked
    }
    onChange(updatedSkills); // Update Formik state
  };

  return (
    <>
      {amenitiesListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
      {amenitiesListError && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('Failed to fetch amenities!')}</div>
        </div>
      )}
      {!amenitiesListLoading && !amenitiesListError && boatAmenitiesList?.length === 0 && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('No amenities found!')}</div>
        </div>
      )}
      {!amenitiesListLoading && !amenitiesListError && boatAmenitiesList?.length > 0 && (
        <div>
          {boatAmenitiesList.map((amenity) => (
            <div key={amenity.code} className="flex items-center">

              <input
                id='amenities'
                name='amenities'
                type="checkbox"
                value={amenity.code}
                checked={value.includes(amenity.code)}
                onChange={handleCheckboxChange}
                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
              />


              <label htmlFor="amenities" className="ml-3 block text-sm font-medium leading-6 text-gray-900">
                {amenity.description.en}
              </label>
            </div>
          ))}
          {error && <p className="text-error text-xs mt-1">{helperText}</p>}
        </div >
      )
      }
    </>
  );
}


